import { connect } from 'react-redux';
import { isVenueDashboardSubtypeFoodAndBeverage } from 'helpers/ia-logic';
import { selectActiveVenue } from 'selectors/general';
import RatingsSummary from './RatingsSummary';
import { selectSelectedClassId, selectSelectedInstructorId } from '../Ratings.selectors';

const mapStateToProps = state => ({
  shouldRenderClassesSummary: !selectSelectedClassId(state),
  shouldRenderInstructorsSummary: !selectSelectedInstructorId(state),
  isVenueFoodAndBeverage: isVenueDashboardSubtypeFoodAndBeverage(selectActiveVenue(state)),
});

export default connect(mapStateToProps)(RatingsSummary);
